export var INTERNAL_PROPS_MARK = 'RC_SELECT_INTERNAL_PROPS_MARK';